<!--
 * @Description: 
 * @Author: lz
 * @Date: 2021-09-06 11:33:38
 * @LastEditTime: 2021-09-09 13:58:06
 * @LastEditors: lz
-->
<template>
  <div style="width: 100%">
    <a-menu mode="inline" theme="light" :openKeys.sync="openKeys" :selectedKeys="[$route.path]" class="cr-menu">
      <template v-for="menu in menus">
        <!-- 一级菜单 -->
        <a-menu-item v-if="!menu.children" :key="menu.path">
          <router-link :to="menu.path">
            <span class="anticon" v-if="menu.meta.icon">
              <svg-icon :icon-class="menu.meta.icon"></svg-icon>
            </span>
            <span>{{ menu.meta.title }}</span>
          </router-link>
        </a-menu-item>
        <!-- 多级菜单 -->
        <SubMenu v-if="menu.children && menu.children.length > 0" :key="menu.path" :menu-info="menu" />
      </template>
    </a-menu>
  </div>
</template>

<script>
import SubMenu from './SubMenu.vue'

export default {
  components: {
    SubMenu
  },

  data() {
    const menus = this.getMenuData(this.$router.options.routes)
    return {
      menus,
      collapsed: false,
      openKeys: []
    }
  },
  watch: {
    $route: {
      handler(to) {
        let matched = to.matched || []
        let openKeys = []
        matched.forEach((route) => {
          openKeys.push(route.path)
        })
        this.openKeys = this.$parent.collapsed ? [] : openKeys
      },
      immediate: true
    },
    '$parent.collapsed': function (val) {
      if (val) {
        this.oldOpenKeys = this.openKeys
        this.openKeys = []
      } else {
        this.openKeys = this.oldOpenKeys || []
      }
    }
  },
  methods: {
    getMenuData(routes = []) {
      let menus = []
      routes.forEach((item) => {
        if (!item.hiddren) {
          let menu = { ...item }
          delete menu.children
          if (item.children && item.children.length > 0) {
            menu.children = this.getMenuData(item.children)
          }
          menus.push(menu)
        }
      })
      return menus
    }
  }
}
</script>
<style lang="less">
.anticon {
  vertical-align: middle !important;
}
.cr-menu {
  height: calc(100vh - 94px);
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
}
</style>
